import { render, staticRenderFns } from "./importForm.vue?vue&type=template&id=65e79c13&scoped=true&"
import script from "./importForm.vue?vue&type=script&lang=js&"
export * from "./importForm.vue?vue&type=script&lang=js&"
import style0 from "./importForm.vue?vue&type=style&index=0&id=65e79c13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e79c13",
  null
  
)

export default component.exports